/**
* description:
* File of sRouter Serivce
*
* Serwis jest odpowiedzialny za obsługę routers.
*
* data : 2017-08-19
*/

const sRouter = (() => {
  return {
    changeUrl,
  };
  // /// PUBLIC /////////////////////////////////////////////////////////////////
  /**
  * Metoda do obsługi routera i zmiany wyświetlanych komponentów.
  * W odpowiedzi przekazuje do routera własciwości 'name' i 'params' wybranej ścieżki.
  *
  * @method changeUrl(pathObject, routerObject)
  * @param {Object} pathObject - obiekt zawierający właściwości do routingu
  * @param {Object} routerObject - obiekt zawierający router
  * @access public
  */
  function changeUrl(pathObject, routerObject) {
    const { name, params } = pathObject;
    routerObject.push({ name, params });
  }
})();

export default sRouter;



// WEBPACK FOOTER //
// ./src/services/sRouter.js